import React from 'react';
import Lock from '@uber/base-icons/lock';
import LockOpen from '@uber/base-icons/lock-open';
import { useSnackbar } from 'baseui/snackbar';
import { LOCK_ANNOTATION_ACTION } from '../../../../common/constant/constant';
import type { ToggleLockAnnotationPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import type { AnnotationInfoT } from '../../annotations/types';
import { SHORT_TOAST_DURATION, SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
import { useSelectedAnnotationLabel } from '../../hooks/use-selected-annotation-label';
type PropsT = {
  annotation: AnnotationInfoT;
};
export function useLockHandler({
  annotation
}: PropsT) {
  const dispatch = useDispatch();
  const selectedAnnotationLabel = useSelectedAnnotationLabel();
  const {
    sendEventForToggleLockAnnotation
  } = useAnalyticsForSidePanel();
  const {
    enqueue
  } = useSnackbar();
  const handleLockAnnotation = (locked: boolean) => {
    dispatch({
      type: SIDE_PANEL_ACTIONS.LOCK_ANNOTATIONS,
      annotationId: annotation.id,
      locked
    });
    const eventPayload: ToggleLockAnnotationPayloadT = {
      objectType: SIDE_PANEL_ACTIONS.LOCK_ANNOTATIONS,
      label: selectedAnnotationLabel?.title ?? '',
      objectId: annotation.id,
      action: locked ? LOCK_ANNOTATION_ACTION.LOCK : LOCK_ANNOTATION_ACTION.UNLOCK
    };
    sendEventForToggleLockAnnotation(eventPayload);
    enqueue({
      message: `Annotation ${locked ? 'locked' : 'unlocked'}.`,
      startEnhancer: () => locked ? React.createElement(Lock, {
        title: 'Locked'
      }) : React.createElement(LockOpen, {
        title: 'Unlocked'
      })
    }, SHORT_TOAST_DURATION);
  };
  return {
    handleLockAnnotation
  };
}